import Labels from "./Labels.js";
import MappaHud from "./MappaHud.js";
import Scene from "./Scene.js";
import Welcome from "./Welcome.js";
import Istruzioni from "./Istruzioni.js";
import Radar from "./Radar.js";
import Wgallery from "./Wgallery.js";
import WinfoImage from "./WinfoImage.js";
import Wyt from "./Wyt.js";
import Wiframe from "./Wiframe.js";
import Wcustom from "./Wcustom.js";
import AddHotspot from "./AddHotspot.js";
import Pqp from "../3x1010/Pqp.js";

export default class Main {

	constructor(baseUrl, userLang, firstSpot, skipwi, hot_hotspot, edit, hot_item, url_rewrite, fhlookat, fvlookat, track) {
		this.userLang = userLang;
		this.baseUrl = baseUrl;
		this.pano = undefined;
		this.firstLoad = true;
		this.menuLingue = undefined;
		this.mappaHud = undefined;
		this.iface = new Array();
		this.mobile = false;
		this.firstSpot = firstSpot;
		this.viewdebug = null;
		this.skipwi = skipwi;
		this.patchedFirstShowInfo = false;
		this.hot_hotspot = hot_hotspot;
		this.hot_item = hot_item;
		this.edit = edit;
		this.lookupOrientamento = new Array();
		this.fastRadar = false;
		this.url_rewrite = url_rewrite;
		this.fhlookat = fhlookat;
		this.fvlookat = fvlookat;
		this.lDaFuori = false;
		this.track = track; // Se si arriva con un link diretto
		console.log(this.track);

		if (!this.firstSpot) {
			this.firstSpot = 0;
		}
		if (Pqp.isMobile()) {
			this.mobile = true;
		}
		this.ios = false;
		if (Pqp.isIos()) {
			this.ios = true;
		}

		if (!this.edit) {
			jQuery(".js-btn-close-edit").hide();
			jQuery(".js-mode-edit").hide();
		} else {
			PLUNGE_SETTINGS.customs.showZoom = false;
		}



		Main.that = this;
		//jQuery(window).append(jQuery(".mcTurn"));

		/*
			$('.owl-carousel').owlCarousel({
				margin:10,
				loop:true,
				autoWidth:true,
				items:4
		})
		*/

	}

	init() {
		// L'engine è stato caricato, lo inizializza
		let lPreserve = false;
		let lWheel = true;
		if (this.edit) {
			lPreserve = true; // Per prendere lo screenshot
			lWheel = false;
		}

		embedpano({
			xml: Customs.pathResources,
			target: "pano",
			html5: "only",
			mobilescale: 1.0,
			passQueryParameters: true,
			mwheel: lWheel,
			capturetouch: lWheel,
			onready: jQuery.proxy(this.onPanoReady, this),
			webglsettings: {
				preserveDrawingBuffer: lPreserve
			}

		});
	}


	onPanoReady(pano) {
		// Salva il riferimento all'oggetto pano
		this.pano = pano;
		Scene.pano = pano;
		Scene.userLang = this.userLang;

		// Setta l'evento sull'onloadcomplete
		pano.set("events.onloadcomplete", "js(trixProxy('Main','onLoadComplete'))");
		
	}

	onLoadComplete() {
		this.setTurnPhone();


		if (this.firstLoad) {
			// Setta i nomi delle scene in lingua
			Scene.setSceneNames();

			// Considera solo il primo caricamento (viene triggerato per ogni scena caricata)
			this.firstLoad = false;

			//jQuery(window).on("click", jQuery.proxy(this.mapHudEventsHandler,this,{type: MappaHud.EVENT_GOTO_SCENE,spot: this.firstSpot,first: true}));


			// Forza la prima scena
			
			this.mapHudEventsHandler({
				type: MappaHud.EVENT_GOTO_SCENE,
				spot: this.firstSpot,
				first: true
			});
			
			//setTimeout(jQuery.proxy(this.showWelcome, this), 250);
			setTimeout(jQuery.proxy(this.showIstruzioni, this), 250);

		}


	}

	setTurnPhone() {
		if (this.mobile) {
			// Gira
			jQuery(".js-gira").html(Main.lbl("turnPhone"));
			jQuery(window).on("resize.info", jQuery.proxy(this.onCheckPortrait, this));
			this.onCheckPortrait();
		}

	}
	showWelcome() {
		// Rimuove il loading
		jQuery(".trix-loading").hide();

		if (!this.skipwi) {
			// Mostra il welcome screen
			let welcome = new Welcome(this.userLang, jQuery.proxy(this.welcomeDismissed, this));
			welcome.init(250);
		} else {
			this.istruzioniDismissed();
		}

	}

	welcomeDismissed() {
		this.showIstruzioni();
	}

	showIstruzioni() {
		jQuery(".trix-loading").hide();
		let istruzioni = new Istruzioni(this.userLang, jQuery.proxy(this.istruzioniDismissed, this));
		istruzioni.init(250);

	}

	istruzioniDismissed() {
		// L'utente ha nascosto le istruzioni
		// Mostra lingua, mappa hud e label della scena
		Main.START_FOV = this.pano.get("view.fov");

		this.initLookupOrientamento();

		this.initUi();
		this.showSceltaLingua();
		if (!this.edit) {
			this.showMappaHud();
		}
		if (PLUNGE_SETTINGS.customs.radar) {
			if (!Pqp.isMobile()) {
				if (!this.edit) {
					this.showRadar();
				}
			}
		}

		// Listsner per aggiungere hotspot
		if (this.edit) {
			this.addKeyListener(true);
			this.disableNavigation();
			this.showCloseFrameEdit();
		} else {
			jQuery(".js-btn-close-edit").hide();

		}

		if (!Pqp.isNullOrEmpty(PLUNGE_SETTINGS.customs.externalLink)) {
			jQuery(".js-goto-ext").on("click", jQuery.proxy(this.gotoExtLink, this));
		} else {
			jQuery(".js-goto-ext").hide();
		}

		this.adjustInfo();

	}

	gotoExtLink() {

		/*let o = {};
		o.action = "external-link";
		o.link = PLUNGE_SETTINGS.customs.externalLink;
		Main.tracking(o);*/

		window.open(PLUNGE_SETTINGS.customs.externalLink, "_blank");
	}

	addKeyListener(lAdd) {
		if (lAdd) {
			jQuery(window).on("keydown.trix", jQuery.proxy(this.onKeyDown, this));
		} else {
			jQuery(window).off("keydown.trix");
		}

	}

	onKeyDown(e) {

		if (e.keyCode == 86) {
			this.addKeyListener(false);
			this.addHotspot();
		}
	}

	initUi() {
		let ui = jQuery("#template-ui").clone();
		ui.attr("id", "ui" + Main.ENUM++);
		jQuery(".js-trix1010").append(ui);
		this.ui = ui;

		let ev = "mousedown"
		if (this.mobile) {
			ev = "touchstart"
		}
		jQuery(".js-image-btn-zoom-in", ui).on(ev, jQuery.proxy(this.beginZoomIn, this))
		jQuery(".js-image-btn-zoom-out", ui).on(ev, jQuery.proxy(this.beginZoomOut, this))
		jQuery(".js-image-btn-fullscreen", ui).on("click", jQuery.proxy(this.toggleFullscreen, this))
		jQuery(".js-image-info", ui).on("click", jQuery.proxy(this.toggleInfo, this, true))


		jQuery(window).on("resize", jQuery.proxy(this.adjustInfo, this));

		if (this.mobile) {
			jQuery(".js-image-btn-zoom-in", this.ui).hide();
			jQuery(".js-image-btn-zoom-out", this.ui).hide();
		}
		if ((this.ios) || (this.edit)) {
			jQuery(".js-image-btn-fullscreen", ui).css("pointer-events", "none");
			jQuery(".js-image-btn-fullscreen", ui).css("opacity", 0);
			jQuery(".js-btns-fsnofs", ui).width("1px");
			jQuery(".trix-btn-interface-right", ui).css("margin-right", 0);
		}

		let logo = jQuery("#template-logo").clone();
		logo.attr("id", "logo" + Main.ENUM++);
		jQuery(".js-trix1010").append(logo);
		this.logo = logo;

		if (!PLUNGE_SETTINGS.customs.showInfo) {
			jQuery(".js-image-info", ui).hide();
		}

		if (!PLUNGE_SETTINGS.customs.showZoom) {
			jQuery(".js-image-btn-zoom-in", this.ui).hide();
			jQuery(".js-image-btn-zoom-out", this.ui).hide();

		}

		if (this.edit) {
			this.logo.hide();

		}

	}

	showSceltaLingua() {
		if (PLUNGE_SETTINGS.customs.showLingue) {
			this.menuLingue = new MenuLingue(userLang, jQuery.proxy(this.onChangedLingua, this));
			this.menuLingue.init();
			this.iface.push(this.menuLingue);
		}

	}

	onChangedLingua(lng) {
		let qs = document.location.href;
		var tmp = ["", ""];
		if (qs.indexOf("?") >= 0) {
			tmp = qs.split("?");
			qs = tmp[0];
		}
		if (tmp[1].length > 0) {
			lng += "&" + tmp[1];
		}

		qs = qs + "?pn=" + lng;
		document.location.href = qs;
	}


	showMappaHud() {
		this.mappaHud = new MappaHud(this.userLang, jQuery.proxy(this.mapHudEventsHandler, this));
		this.mappaHud.init();
	}

	mapHudEventsHandler(e) {
		
		if (e.type == MappaHud.EVENT_GOTO_SCENE) {
			this.fastRadar = true;
			Scene.gotoScene(e.spot, e.first);
			setTimeout(jQuery.proxy(this.checkOpenHs, this), 500)
		}
	}


	showRadar() {
		this.radar = new Radar(this.userLang, jQuery.proxy(this.radarEventsHandler, this));
		this.radar.init();
	}

	radarEventsHandler(e) {
	}


	checkOpenHs() {
		if (this.hot_hotspot) {
			let hhs = this.hot_hotspot.split("|")[0];
			let tmp = this.hot_hotspot.split("|");
			let parm = null;
			if (tmp.length > 1) {
				parm = tmp[1];
			}
			//let hs = Scene.getHotspotByName(hot_hotspot)
			let hs = Scene.getHotspotByName(hhs)
			if (hs) {
				this.lDaFuori = true;
				this.handleHotspot(hhs, null, parm, this.hot_item);
				this.lDaFuori = false;
				//this.handleHotspot(hot_hotspot, null, parm);
			} else {
				this.track = false;
			}
			this.hot_hotspot = null;
		} else {
			this.track = false;
		}

	}
	moveAndTag(action, category, label) {
		console.log("AA")

		/*if (this.radar) {
			this.radar.destroyed = true;
		}*/
		//console.log(action, category, label);
		try {
			this.setInfo();
		} catch (e) {

		}
		let o = new Object();
		o.action = action;
		o.language = category;
		o.station = label;
		let area = Scene.getSceneByName(label);
		o.area = area.area;
		o.spot = area.spot;
		o.name = area.RenderDescription;
		Main.tracking(o);

		this.enteredScene(area);
	}


	handleHotspot(hs, altId, parm, item) {
		
		let hslocal = Scene.getHotspotByName(hs)
		if (altId) {
			hslocal = Scene.getHotspotByName(altId)
		}

		let o = new Object();
		o.action = "clicked-hotspot";
		o.language = this.userLang;
		let area = Scene.getCurrentScene();
		o.station = area.name;
		o.area = area.area;
		o.spot = area.spot;
		o.hotspot = hs;
		o.parm = parm;
		o.item = item;
		if (altId) {
			o.hotspot = altId;
		}

		//console.log(o)
		//Main.tracking(o);

		if (hs != "hotspot_video") {
			this.executeActionHotspot(hslocal, o);
			//setTimeout(this.executeActionHotspot.bind(this, hslocal, o), 1000);
		}
		this.track = false;

	}

	executeActionHotspot(hslocal, o) {
		if (!hslocal) {
			Main.alert("ATTENZIONE!", "Non è stato trovato nessun riferimento all'hotspot '" + o.hotspot + "'.<br>Controllare il documento fogli di google.");
			return
		}
		let tra = new Object();
		tra.action = "clicked-hotspot";
		tra.hotspot = hslocal.tipo;
		tra.testo_it = hslocal.testo_it;
		Main.tracking(tra);


		let widget;
		if (hslocal.tipo == "gallery") {
			hslocal.template = Wgallery.T_MULTIPLA;
			widget = new Wgallery(hslocal, o, jQuery.proxy(this.hotspotsEventHandler, this));
		}
		if ((hslocal.tipo == "iframe") || (hslocal.tipo == "info")) {
			widget = new Wiframe(hslocal, o, jQuery.proxy(this.hotspotsEventHandler, this));
		}
		if (hslocal.tipo == "youtube") {
			widget = new Wyt(hslocal, o, jQuery.proxy(this.hotspotsEventHandler, this));
		}
		if (hslocal.tipo == "infoimage") {
			widget = new WinfoImage(hslocal, o, jQuery.proxy(this.hotspotsEventHandler, this));
		}
		if ((hslocal.tipo == "linkext") || (hslocal.tipo == "scendigiu") || (hslocal.tipo == "salisu") || (hslocal.tipo == "vaidila") || (hslocal.tipo == "salisuqui") || (hslocal.tipo == "scendigiuqui") || (hslocal.tipo == "exit") || (hslocal.tipo == "enter") || (hslocal.tipo == "goon") || (hslocal.tipo == "arrow_down_left") || (hslocal.tipo == "arrow_down_right") || (hslocal.tipo == "arrow_up_left") || (hslocal.tipo == "arrow_up_right")) {
			widget = new Wcustom(hslocal, o, jQuery.proxy(this.hotspotsEventHandler, this), this.lDaFuori);
		}
		if (widget) {
			widget.init();
		} else {
			Main.alert("ATTENZIONE!", "L'hotspot '" + hslocal.name + "' appartiene ad una tipologia che non è stata ancora gestita.");
		}
	}

	hotspotsEventHandler(e) {

		if (e.type == Main.HS_EVENT_HIDE_INTERFACE) {
			Main.sfoca(true);
			Main.showInterface(false)
		}
		if (e.type == Main.HS_EVENT_SHOW_INTERFACE) {
			Main.sfoca(false);
			Main.showInterface(true)
		}
	}

	
	beginZoomIn() {
		let ev = "mouseup"
		if (this.mobile) {
			ev = "touchend"
		}
		this.zoomIn();
		jQuery(window).off(ev);
		jQuery(window).on(ev, jQuery.proxy(this.clearZoom, this));
		//console.log("START PRESS")
	}
	beginZoomOut() {
		let ev = "mouseup"
		if (this.mobile) {
			ev = "touchend"
		}
		this.zoomOut();
		jQuery(window).off(ev);
		jQuery(window).on(ev, jQuery.proxy(this.clearZoom, this));
		//console.log("START PRESS")

	}

	zoomIn() {
		Main.FOV = this.pano.get("view.fov");
		Main.FOV -= Main.INC_DEC_ZOOM;
		this.pano.set("view.fov", Main.FOV)
		this.idzoom = setTimeout(jQuery.proxy(this.zoomIn, this), 20);
	}

	zoomOut() {
		Main.FOV = this.pano.get("view.fov");
		Main.FOV += Main.INC_DEC_ZOOM;
		this.pano.set("view.fov", Main.FOV)
		this.idzoom = setTimeout(jQuery.proxy(this.zoomOut, this), 20);
	}
	clearZoom() {
		let ev = "mouseup"
		if (this.mobile) {
			ev = "touchend"
		}
		jQuery("window").off(ev);

		clearTimeout(this.idzoom);
	}

	toggleFullscreen() {
		//console.log(document.fullscreenElement);
		if (document.fullscreenElement) {
			document.exitFullscreen();
		} else {
			let element = jQuery(".trix1010").get(0);
			element.requestFullscreen();
		}
	}

	showInfoForced() {
		if (PLUNGE_SETTINGS.customs.showInfo) {
			let mc = jQuery(".js-infos", this.ui);
			if (!mc.is(":visible")) {
				this.toggleInfo(true);
			}
		}

	}

	toggleInfo(lAnim) {
		if (PLUNGE_SETTINGS.customs.showInfo) {
			let mc = jQuery(".js-infos", this.ui);
			let title = jQuery(".js-title-container", this.ui);
			let panel = jQuery(".js-title-panel", this.ui);
			if (mc.is(":visible")) {
				mc.hide();
				title.hide();
				jQuery(".js-image-info", this.ui).css("background-color", "transparent");
				jQuery(".js-pez").remove();
				
			} else {
				mc.show();
				title.show();
				this.setInfo();
				jQuery(".js-image-info", this.ui).css("background-color", "rgba(255,255,255,0.8)");
				if (lAnim) {
					mc.css({
						opacity: 0
					})
					TweenMax.to(mc, 0.2, {
						opacity: 1
					});
					panel.css({
						top: panel.height()
					})
					TweenMax.to(panel, 0.2, {
						top: 0
					});
				} else {
					panel.css({
						top: 0
					});
				}

				this.pezza = jQuery("<div class='js-pez'></div>");
				this.pezza.css("height", "1px")
				this.pezza.css("position", "absolute")
				this.pezza.css("width", "100%")
				this.pezza.css("top", "-1px")
				this.pezza.css("background-color", "rgba(255,255,255,0.8)");
				jQuery(".js-image-info", this.ui).parent().append(this.pezza);





			}

			this.adjustInfo();
		}

	}

	setInfo() {
		var scene = Scene.getCurrentScene();
		jQuery(".js-title-h", this.ui).html(scene["title_" + this.userLang.toLowerCase()])
		jQuery(".js-title", this.ui).html("");
		jQuery(".js-desc", this.ui).html(scene["desc_" + this.userLang.toLowerCase()])
		this.adjustInfo();
	}
	/*
	adjustInfo() {
	
		let mc = jQuery(".js-infos", this.ui);
	
		if (mc.is(":visible")) {
			let margin = jQuery(".js-sx", this.ui).width() * 0.01;
			let begx = jQuery(".js-image-info", this.ui).offset().left + jQuery(".js-image-info", this.ui).width();
	
			let oz = jQuery(".js-image-btn-zoom-in", this.ui).offset().left;
			if (this.mobile) {
				oz = jQuery(".js-btns-fsnofs", this.ui).offset().left;
			}
	
			let winfos = oz - begx - margin;
	
			mc.css({
				left: begx,
				width: winfos
			});
	
			margin = jQuery(".js-sx", this.ui).width() * 0.02;
			let ofsx = jQuery(".js-isx", this.ui).width() + margin * 2;
			jQuery(".js-isx", this.ui).css("margin-left", margin);
			jQuery(".js-isx", this.ui).css("margin-right", margin);
			let banw = jQuery(".js-ban", this.ui).width();
			let wdx = banw - ofsx - margin;
			jQuery(".js-idx", this.ui).width(wdx);
		}
	
		if (document.fullscreenElement) {
			jQuery(".js-btn-fs", this.ui).hide();
			jQuery(".js-btn-nofs", this.ui).show();
		} else {
			jQuery(".js-btn-nofs", this.ui).hide();
			jQuery(".js-btn-fs", this.ui).show();
		}
	
	
	}
	*/

	adjustInfo() {
		//console.log("adjust!")
		let mleft = jQuery(".js-trix1010").offset().left;
		let mc = jQuery(".js-infos", this.ui);

		if (mc.is(":visible")) {
			let margin = jQuery(".js-sx", this.ui).width() * 0.01;
			let begx = jQuery(".js-image-info", this.ui).offset().left + jQuery(".js-image-info", this.ui).width();

			let oz = jQuery(".js-image-btn-zoom-in", this.ui).offset().left;
			if (this.mobile) {
				oz = jQuery(".js-btns-fsnofs", this.ui).offset().left;
			}
			if (!PLUNGE_SETTINGS.customs.showZoom) {
				oz = jQuery(".js-btns-fsnofs", this.ui).offset().left;
			}


			let winfos = oz - begx - margin;

			mc.css({
				left: begx - mleft,
				width: winfos
			});

			margin = jQuery(".js-sx", this.ui).width() * 0.02;
			let ofsx = jQuery(".js-isx", this.ui).width() + margin //* 2;
			jQuery(".js-isx", this.ui).css("margin-left", margin);
			//jQuery(".js-isx", this.ui).css("margin-right", margin);
			let banw = jQuery(".js-ban", this.ui).width();
			let wdx = banw - ofsx - margin;
			jQuery(".js-idx", this.ui).width(wdx);

			// il titolo
			let title = jQuery(".js-title-container", this.ui);
			title.show();
			let paneltitleh = jQuery(".js-title-panel", this.ui).outerHeight();
			let begtx = jQuery(".js-image-info", this.ui).offset().left;
			let begty = -paneltitleh+1;
			let wt = jQuery(".js-image-info", this.ui).width() + winfos


			title.css({
				left: begtx - mleft,
				top: begty,
				width: wt,
				height: paneltitleh
			})

			let mart = jQuery(".js-image-info", this.ui).width() + margin;
			jQuery(".js-title-h", this.ui).css("margin-left", mart);


			jQuery(".js-infos", this.ui).off("click");
			jQuery(".js-title-panel", this.ui).off("click");
			jQuery(".js-infos", this.ui).on("click", jQuery.proxy(this.toggleInfo, this, true))
			jQuery(".js-title-panel", this.ui).on("click", jQuery.proxy(this.toggleInfo, this, true))



		}

		if (document.fullscreenElement) {
			jQuery(".js-btn-fs", this.ui).hide();
			jQuery(".js-btn-nofs", this.ui).show();
		} else {
			jQuery(".js-btn-nofs", this.ui).hide();
			jQuery(".js-btn-fs", this.ui).show();
		}


	}



	onViewChanged() {
		//console.log(e)
		if (!this.viewInited) {
			this.viewInited = true;
			let vi = jQuery("#template-viewc").clone();
			vi.attr("id", "tvirw" + Main.ENUM++);
			jQuery(".js-trix1010").append(vi);
			this.viewdebugcount = 0;
			this.viewdebug = vi;
			this.viewdebug.on("click", jQuery.proxy(this.contaCheat, this));
			vi.css("z-index", 10);
		}
		let view = this.pano.get("view");
		this.pano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv)");
		let mouse_at_x = this.pano.get("mouse.x");
		let mouse_at_y = this.pano.get("mouse.y");
		let mouse_at_h = this.pano.get("mouseath");
		let mouse_at_v = this.pano.get("mouseatv");
		this.viewdebug.html("hlookat: " + view.hlookat + "<br>vlookat: " + view.vlookat + "<br>ath: " + mouse_at_h + "<br>atv: " + mouse_at_v + "<br>mousex: " + mouse_at_x + "<br>mousey: " + mouse_at_y);

	}

	contaCheat() {
		this.viewdebugcount++;
		if (this.viewdebugcount == 3) {
			this.viewdebug.css("opacity", "1");
			this.viewdebug.css("display", "inline-block");
		}

	}

	onCheckPortrait() {
		if (this.mobile) {
			var w = jQuery(window).outerWidth();
			var h = jQuery(window).outerHeight();
			//console.log(w, h)
			//if (h > 500) {
			if (h > w) {
				jQuery(".mcTurn").show();
			} else {
				jQuery(".mcTurn").hide();
				var h = jQuery(window).height();
				jQuery("body").css("height", h);
				jQuery("body").css("width", "99.9vw");
				jQuery(".js-trix1010").height(h)

				/*try{
					document.exitFullscreen();
				}catch(e){
					
				}*/

			}
			//}
		}
	}

	enteredScene(area) {
		//console.log(area);
		//console.log(this.pano)
		//if (area.showOnMap) {
		//let view = this.pano.get("view");
		//this.viewdebug.html(view.hlookat + "<br>" + view.vlookat)
		//console.log(view)




		if (!this.patchedFirstShowInfo) {
			this.showInfoForced();
			this.patchedFirstShowInfo = true;
			this.idseti = setInterval(jQuery.proxy(this.adjustInfo, this), 10);
		} else {
			clearInterval(this.idseti);
		}
		/*}else{
			clearInterval(this.idseti);
		}*/

		let quanti = this.pano.get('hotspot.count');
		for (var x = 0; x < quanti; x++) {
			var hs = this.pano.get('hotspot[' + x + ']');
			if (hs.scene_el == area.name) {
				if (hs.triggeraAnimazione) {
					// console.log("Triggero "+hs.title);
					//Scene.startHsAnimation(hs,hs.oldWidth)
					setTimeout(jQuery.proxy(Scene.startHsAnimation, Scene, hs, hs.oldWidth), 100);
				}
			}
		}

		if (Main.that.radar) {
			Main.that.radar.reset(this.fastRadar);
			this.fastRadar = false;
		}

		//setTimeout(jQuery.proxy(this.removeHotspotNavigation, this), 100);

		// Aggiusta l'url 
		Main.setUrl(Scene.getCurrentScene().name, null, null)


	}

	static setUrl(scena, hotspot, item) {
		if (!Main.that.url_rewrite) {
			return;
		}
		let location = window.location.href
		if (location.indexOf("?") >= 0) {
			location = location.split("?")[0];
		}

		if (hotspot) {
			location += "?hs=" + hotspot
		} else {
			location += "?loc=" + Scene.getSceneByName(scena).spot;
		}

		window.history.replaceState(null, null, location);
	}

	patchaVideo(hs, w, h) {
		//console.log("PATCH " + w + " " + h)
		hs.width = w;
		hs.height = h;
	}

	static showInterface(lFlag) {
		let iface = Main.that.iface;
		for (let x = 0; x < iface.length; x++) {
			iface[x].showWidget(lFlag);
		}
		if (lFlag) {
			Main.that.ui.show();
			if (Customs.logoTopLeft) {
				if (!Main.that.edit) {
					Main.that.logo.show();
				}
			}
			if (Main.that.edit) {
				jQuery(".js-btn-close-edit").show();
				jQuery(".js-mode-edit").show();
			}
			if (Main.that.radar) {
				Main.that.radar.show(true);
			}
			jQuery(".js-logo-ui").show();

		} else {
			Main.that.ui.hide();
			if (Customs.logoTopLeft) {
				if (!Main.that.edit) {
					Main.that.logo.hide();
				}
			}
			if (Main.that.edit) {
				jQuery(".js-btn-close-edit").hide();
				jQuery(".js-mode-edit").hide();
			}
			if (Main.that.radar) {
				Main.that.radar.show(false);
			}
			jQuery(".js-logo-ui").hide();

		}
	}

	static sfoca(lFlag) {
		if (lFlag) {
			jQuery(Main.that.pano).addClass("blur-effect");
		} else {
			jQuery(Main.that.pano).removeClass("blur-effect");
		}
	}

	static lbl(id) {
		let a = Labels.LABELS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id == id) {
				return a[x]["value_" + Main.that.userLang.toLowerCase()];
			}
		}
		return "[" + id + "]";
	}

	static alert(title, message) {
		let alert = new Walert(title, message);
		alert.init();
	}

	static getYoutubeString(code) {

		var s = "//www.youtube.com/embed/";
		if (code.length == 11) {
			Main.debugTrace("VIDEO SINGOLO")
			// Video singolo
			s += code + "?start=0&cc_lang_pref=" + Main.that.userLang + "&cc_load_policy=1&hl=" + Main.that.userLang + "&color=white&autohide=0&iv_load_policy=3&autoplay=1&mute=1&rel=0&showinfo=0&controls=1&loop=1&playlist=" + code;
		} else {
			Main.debugTrace("PLAYLIST")
			// Playlist
			s += code + "?start=0&cc_lang_pref=" + Main.that.userLang + "&cc_load_policy=1&hl=" + Main.that.userLang + "&color=white&autohide=0&iv_load_policy=3&autoplay=1&mute=1&rel=0&showinfo=0&controls=1&loop=1&listType=playlist&list=" + code;
		}
		return s;
	}

	static debugTrace(xValue) {
		if (Main.SHOW_DEBUG_INFO) {
			console.log(xValue);
		}

	}




	addHotspot() {
		// Nasconde le altre hotspots
		this.showAllHotspots(false);
		// Aggiunge la hotspot dummy
		this.addDummyHotspot();
		// Disabilita le interazioni
		jQuery(".js-disabler").show();

	}

	getScreenshot() {
		var c = jQuery("canvas").get(0);
		var d = c.toDataURL("image/png");

		var canvas = document.getElementById("tmp-snapshot");
		var ctx = canvas.getContext("2d");
		var img = new Image();
		img.onload = function(){
			// set size proportional to image
			canvas.height = canvas.width * (img.height / img.width);

			// step 1 - resize to 50%
			var oc = document.createElement('canvas'),
				octx = oc.getContext('2d');
			oc.width = img.width * 0.5;
			oc.height = img.height * 0.5;
			octx.drawImage(img, 0, 0, oc.width, oc.height);
			// step 2
			octx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5);
			// step 3, resize to final size
			ctx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5,
				0, 0, canvas.width, canvas.height);
		}
		img.src = d;

		setTimeout(jQuery.proxy(this.showAddHotspotWindow, this, canvas), 100);

	}

	addDummyHotspot() {
		this.pano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv)");
		let hlookat = this.pano.get("mouseath");
		let vlookat = this.pano.get("mouseatv");
		this.dummyHlookat = hlookat;
		this.dummyVlookat = vlookat;

		var spotname = "dummy" + Main.ENUM++;
		this.pano.call("addhotspot(" + spotname + ");");
		this.pano.call("set(hotspot[" + spotname + "].url,/Plunge/assets/hotspots/hotspot_add.png;");
		this.pano.call("set(hotspot[" + spotname + "].ath," + hlookat + ");");
		this.pano.call("set(hotspot[" + spotname + "].atv," + vlookat + ");");
		this.pano.call("set(hotspot[" + spotname + "].onloaded,js(dummyHotSpotAdded()));");
		this.pano.call("set(hotspot[" + spotname + "].trixCustom,true)");

		let h = this.pano.get("hotspot[" + spotname + "]");
		this.dummyHotspot = h;
		//console.log("---------------");
		//console.log(hlookat, vlookat)

	}

	showAllHotspots(lFlag) {
		for (let x = 0; x < this.pano.get('hotspot.count'); x++) {
			let h = this.pano.get("hotspot[" + x + "]");

			if (lFlag) {
				//console.log(h)
				if (!h.trixCustom) {
					if (h.oriwidth) {
						h.width = h.oriwidth;
						h.height = h.oriheight;
					}
				}
			} else {
				if (!h.oriwidth) {
					h.oriwidth = h.width;
					h.oriheight = h.height;
				}
				h.width = 0.1;
				h.height = 0.1;
			}
		}
	}


	showAddHotspotWindow(canvas) {
		var d = canvas.toDataURL("image/png");
		/*var w = window.open('about:blank', 'image from canvas');
		w.document.write("<img src='" + d + "' alt='from canvas'/>");*/

		Main.showInterface(false)


		let view = this.pano.get("view");
		let payload = new Object();
		payload.ath = this.dummyHlookat
		payload.atv = this.dummyVlookat
		payload.bd = d
		payload.hlookat = view.hlookat;
		payload.vlookat = view.vlookat;

		let ah = new AddHotspot(jQuery.proxy(this.hotspotAddedOrDismissed, this), payload);
		ah.init();
		jQuery(".js-disabler").hide();


	}


	hotspotAddedOrDismissed(lAdded) {
		this.showAllHotspots(true);
		this.addKeyListener(true);
		this.dummyHotspot.visible = false;
		if (lAdded) {
			this.onCloseModeEdit(lAdded);
		}
	}


	disableNavigation() {
		let total = this.pano.get('scene.count')
		let toDel = new Array();
		for (let x = 0; x < total; x++) {
			let scene = this.pano.get("scene[" + x + "]");
			if (scene.name != Scene.getCurrentScene().name) {
				toDel.push(scene.name);
			}
		}

		for (let x = 0; x < toDel.length; x++) {
			this.pano.call('set(scene["' + toDel[x] + '"].name, null)');
		}

		this.removeHotspotNavigation();


	}

	removeHotspotNavigation() {
		//console.log(this.pano.get('hotspot.count'))
		for (let x = 0; x < this.pano.get('hotspot.count'); x++) {
			let h = this.pano.get("hotspot[" + x + "]");
			if (h.loadedurl == "<textfield>") {
				h.visible = false;
			}
		}
	}

	showCloseFrameEdit() {
		jQuery(".js-btn-close-edit").show();
		jQuery(".js-btn-close-edit").on("click", jQuery.proxy(this.onCloseModeEdit, this, false));
	}

	onCloseModeEdit(lAdded, e) {

		try {
			window.parent._hotSpotCmsHandler("close")
		} catch (e) {
			console.log("CLOSE")
		}
	}

	initLookupOrientamento() {

		let quanti = this.pano.get("style").count;
		for (let x = 0; x < quanti; x++) {
			let o = this.pano.get("style[" + x + "]");
			this.lookupOrientamento.push(o);
		}
	}

	getOrientamentoBySceneName(name) {
		let a = this.lookupOrientamento;
		for (let x = 0; x < a.length; x++) {
			if (a[x].linkedscene == name) {
				return a[x];
			}
		}
		return null;
	}

	static tracking(o) {
		//console.log(o)
		let layer = null;
		let sce = Scene.getCurrentScene();
		let caption = sce.caption;
		let spot = sce.spot;
		//console.log("scene" + spot);

		if (o.action == "clicked-hotspot") {
			//let hs = Scene.getHotspotByName(o.hotspot);
			layer = {
				'event': 'GAevent',
				'eventCategory': o.action,
				'eventAction': o.hotspot + "_" + Main.normalizza(o.testo_it)
			}

		}
		if (o.action == "reached-station") {
			layer = {
				'event': 'GAevent',
				'eventCategory': o.action,
				'eventAction': Main.normalizza(o.name) //+ "(" + o.station + ")"
			}
		}

		if (layer) {
			if (Main.that.track) {
				layer.eventCategory = "auto_" + layer.eventCategory;
			}

			console.log("---tracking---");
			console.log("Event: " + layer.eventCategory);
			console.log("Category: " + "tour_" + Main.normalizza(PLUNGE_SETTINGS.customs.nomeNegozio));
			console.log("Label: " + "scene" + spot + "_" + caption + "_" + layer.eventAction);

			gtag('event', layer.eventCategory, {
				'event_category': "tour_" + Main.normalizza(PLUNGE_SETTINGS.customs.nomeNegozio),
				'event_label': "scene" + spot + "_" + caption + "_" + layer.eventAction
			});
		}


	}
	static normalizza(s) {
		let ret = s.toLowerCase();
		ret = Pqp.safeReplace(ret, " ", "_");
		ret = Pqp.safeReplace(ret, "'", "_");
		ret = Pqp.safeReplace(ret, ".", "");
		ret = Pqp.safeReplace(ret, ",", "");
		ret = Pqp.safeReplace(ret, "(", "_");
		ret = Pqp.safeReplace(ret, ")", "");
		ret = Pqp.safeReplace(ret, "__", "_");
		return ret;
	}


}

Main.IS_US = false;
Main.INC_DEC_ZOOM = 2;
Main.SHOW_DEBUG_INFO = false;

Main.HS_EVENT_HIDE_INTERFACE = "eventHsHideInterface";
Main.HS_EVENT_SHOW_INTERFACE = "eventHsShowInterface";

Main.ENUM = 0;

